/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ats_Tip_Add_NameInputs */

const en_ats_tip_add_name = /** @type {(inputs: Ats_Tip_Add_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add your full name to the contact section`)
};

const de_ats_tip_add_name = /** @type {(inputs: Ats_Tip_Add_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Füge deinen vollständigen Namen im Kontaktbereich hinzu`)
};

const fr_ats_tip_add_name = /** @type {(inputs: Ats_Tip_Add_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajoutez votre nom complet dans la section contact`)
};

const es_ats_tip_add_name = /** @type {(inputs: Ats_Tip_Add_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Añade tu nombre completo en la sección de contacto`)
};

const it_ats_tip_add_name = /** @type {(inputs: Ats_Tip_Add_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiungi il tuo nome completo nella sezione contatti`)
};

const nl_ats_tip_add_name = /** @type {(inputs: Ats_Tip_Add_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voeg je volledige naam toe in de contactsectie`)
};

const pl_ats_tip_add_name = /** @type {(inputs: Ats_Tip_Add_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dodaj swoje pełne imię i nazwisko w sekcji kontaktowej`)
};

const fi_ats_tip_add_name = /** @type {(inputs: Ats_Tip_Add_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lisää koko nimesi yhteystietosektioon`)
};

const da_ats_tip_add_name = /** @type {(inputs: Ats_Tip_Add_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tilføj dit fulde navn i kontaktsektionen`)
};

const sv_ats_tip_add_name = /** @type {(inputs: Ats_Tip_Add_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lägg till ditt fullständiga namn i kontaktsektionen`)
};

/**
* | output |
* | --- |
* | "Add your full name to the contact section" |
*
* @param {Ats_Tip_Add_NameInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const ats_tip_add_name = /** @type {((inputs?: Ats_Tip_Add_NameInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ats_Tip_Add_NameInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_ats_tip_add_name(inputs)
	if (locale === "fr") return fr_ats_tip_add_name(inputs)
	if (locale === "es") return es_ats_tip_add_name(inputs)
	if (locale === "it") return it_ats_tip_add_name(inputs)
	if (locale === "nl") return nl_ats_tip_add_name(inputs)
	if (locale === "pl") return pl_ats_tip_add_name(inputs)
	if (locale === "fi") return fi_ats_tip_add_name(inputs)
	if (locale === "da") return da_ats_tip_add_name(inputs)
	if (locale === "sv") return sv_ats_tip_add_name(inputs)
	return en_ats_tip_add_name(inputs)
});